var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1269,
    height: 768,
    viewBox: "0 0 1269 768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(88 -226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2462",
    "data-name": "Rectangle 2462",
    transform: "translate(289 226)",
    fill: "#f1f1f1",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 892,
    height: 177,
    rx: 88.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 891,
    height: 176,
    rx: 88,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    transform: "translate(316 247)",
    fill: "#f8c95a",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 68,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 67.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(374 333)",
    fill: "#fff",
    fontSize: 47,
    fontFamily: "'\\\\\\\\.AppleSystemUIFont'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2463",
    "data-name": "Rectangle 2463",
    transform: "translate(289 615)",
    fill: "#f1f1f1",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 879,
    height: 177,
    rx: 88.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 878,
    height: 176,
    rx: 88,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    transform: "translate(316 636)",
    fill: "#f05a24",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 68,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 67.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(367 722)",
    fill: "#fff",
    fontSize: 47,
    fontFamily: "'\\\\\\\\.AppleSystemUIFont'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2464",
    "data-name": "Rectangle 2464",
    transform: "translate(-88 419)",
    fill: "#f1f1f1",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 832,
    height: 177,
    rx: 87,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 831,
    height: 176,
    rx: 86.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    transform: "translate(584 440)",
    fill: "#12315f",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 68,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 67.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(642 524)",
    fill: "#fff",
    fontSize: 47,
    fontFamily: "'\\\\\\\\.AppleSystemUIFont'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2465",
    "data-name": "Rectangle 2465",
    transform: "translate(-88 817)",
    fill: "#f1f1f1",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 832,
    height: 177,
    rx: 88.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 831,
    height: 176,
    rx: 88,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    transform: "translate(584 838)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 68,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 67.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": 4,
    transform: "translate(636 922)",
    fill: "#fff",
    fontSize: 47,
    fontFamily: "'\\\\\\\\.AppleSystemUIFont'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("text", {
    id: "PHASE_",
    "data-name": "PHASE ",
    transform: "translate(113 321)",
    fontSize: 47,
    fontFamily: "'\\\\\\\\.AppleSystemUIFont'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PHASE ")), /*#__PURE__*/React.createElement("text", {
    id: "PHASE_2",
    "data-name": "PHASE ",
    transform: "translate(769 523)",
    fontSize: 47,
    fontFamily: "'\\\\\\\\.AppleSystemUIFont'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PHASE ")), /*#__PURE__*/React.createElement("text", {
    id: "PHASE_3",
    "data-name": "PHASE ",
    transform: "translate(113 723)",
    fontSize: 47,
    fontFamily: "'\\\\\\\\.AppleSystemUIFont'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PHASE ")), /*#__PURE__*/React.createElement("text", {
    id: "PHASE_4",
    "data-name": "PHASE ",
    transform: "translate(769 920)",
    fontSize: 47,
    fontFamily: "'\\\\\\\\.AppleSystemUIFont'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PHASE ")), /*#__PURE__*/React.createElement("text", {
    id: "Initiation_:_1_Month",
    "data-name": "Initiation : 1 Month",
    transform: "translate(474 291)",
    fontSize: 30,
    fontFamily: "Helvetica",
    textDecoration: "underline"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Initiation : 1 Month")), /*#__PURE__*/React.createElement("text", {
    id: "Create_Essential_Security_Requirements_ESR_",
    "data-name": "Create Essential Security Requirements (ESR) ",
    transform: "translate(474 333)",
    fontSize: 30,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Create Essential Security Requirements"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 36
  }, "(ESR)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 72
  })), /*#__PURE__*/React.createElement("text", {
    id: "Planning_:_1_Month",
    "data-name": "Planning : 1 Month",
    transform: "translate(306 481)",
    fontSize: 30,
    fontFamily: "Helvetica",
    textDecoration: "underline"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Planning : 1 Month")), /*#__PURE__*/React.createElement("text", {
    id: "Form_Technical_Community_TC_",
    "data-name": "Form Technical Community (TC)",
    transform: "translate(556 532)",
    fontSize: 30,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -431,
    y: 0
  }, "Form Technical Community (TC)")), /*#__PURE__*/React.createElement("text", {
    id: "Publishing_:_1_Month",
    "data-name": "Publishing : 1 Month",
    transform: "translate(286 884)",
    fontSize: 30,
    fontFamily: "Helvetica",
    textDecoration: "underline"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Publishing : 1 Month")), /*#__PURE__*/React.createElement("text", {
    id: "Obtain_Approval_for_Public_Release_Posting_on_NIAP_Website",
    "data-name": "Obtain Approval for Public Release Posting on NIAP Website",
    transform: "translate(556 929)",
    fontSize: 30,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -465,
    y: 0
  }, "Obtain Approval for Public Release"), /*#__PURE__*/React.createElement("tspan", {
    x: -335,
    y: 36
  }, "Posting on NIAP Website")), /*#__PURE__*/React.createElement("text", {
    id: "Development_:_3-4_Months",
    "data-name": "Development : 3-4 Months",
    transform: "translate(474 684)",
    fontSize: 30,
    fontFamily: "Helvetica",
    textDecoration: "underline"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Development : 3-4 Months")), /*#__PURE__*/React.createElement("text", {
    id: "Create_Essential_Security_Requirements_ESR_2",
    "data-name": "Create Essential Security Requirements (ESR) ",
    transform: "translate(474 728)",
    fontSize: 30,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Define Threats, Security Requirements, and"), /*#__PURE__*/React.createElement("tspan", {
    x: 320,
    y: 36
  }, "Assurance Activities")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpProcess);
export default __webpack_public_path__ + "static/media/pp-process.5fac6bf443a639c1f650e0e39ebec5fb.svg";
export { ForwardRef as ReactComponent };